<!-- ==========================================================================
     ARCHIVO DE CONFIGURACIÓN
     ========================================================================== -->

<div class="config-file-container">

    <!-- ======================================================================
         HEADER PRINCIPAL
         ====================================================================== -->

    <div class="config-file-header">

        <div class="config-header-main">

            <div class="config-header-icon">
                <i class="fa-solid fa-file-code"></i>
            </div>

            <div class="config-header-content">

                <span class="config-eyebrow">
                    CONFIGURACIÓN
                </span>

                <h4>
                    Archivo de configuración
                </h4>

                <p>
                    Carga o edita el archivo JavaScript utilizado por el servicio.
                </p>

            </div>

        </div>


        <!-- Estado cuando existe archivo -->

        <span class="config-status" *ngIf="archivo">

            <span class="config-status-dot"></span>

            Archivo cargado

        </span>

    </div>


    <!-- ======================================================================
         CONTENIDO
         ====================================================================== -->

    <div class="config-file-body">


        <!-- ==================================================================
             UPLOAD
             ================================================================== -->

        <div class="upload-section" *ngIf="!archivo">

            <div class="section-heading">

                <div class="section-heading-icon">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                </div>

                <div>

                    <h5>
                        Cargar archivo
                    </h5>

                    <p>
                        Selecciona el archivo JavaScript que deseas utilizar.
                    </p>

                </div>

            </div>


            <div class="upload-wrapper">

                <app-file-upload data-tour="upload-dropzone" #fileUpload (fileSelected)="handleFiles($event)"
                    [multiple]="multiple" [extension]="['js']" [maxFiles]="maxFile" [maxFileSize]="maxFileSize">
                </app-file-upload>

            </div>


            <div class="upload-help">

                <div class="upload-help-item">

                    <i class="fa-solid fa-file-code"></i>

                    <span>
                        Formato permitido:
                        <strong>.js</strong>
                    </span>

                </div>


                <div class="upload-help-item">

                    <i class="fa-solid fa-shield-halved"></i>

                    <span>
                        Verifica el contenido antes de guardar.
                    </span>

                </div>

            </div>

        </div>


        <!-- ==================================================================
             EDITOR
             ================================================================== -->

        <ng-container *ngIf="archivo">

            <div class="editor-section">

                <!-- ----------------------------------------------------------
                     INFORMACIÓN DEL ARCHIVO
                     ---------------------------------------------------------- -->

                <div class="editor-file-info">

                    <div class="editor-file-main">

                        <div class="editor-file-icon">
                            <i class="fa-brands fa-js"></i>
                        </div>


                        <div class="editor-file-name">

                            <span class="editor-label">
                                ARCHIVO ACTUAL
                            </span>

                            <strong>
                                {{ nombreArchivo }}
                            </strong>

                        </div>

                    </div>


                    <div class="editor-file-meta">

                        <span class="file-language">
                            JavaScript
                        </span>

                        <span class="editable-status">

                            <i class="fa-solid fa-pen"></i>

                            Editable

                        </span>

                    </div>

                </div>


                <!-- ----------------------------------------------------------
                     HEADER EDITOR
                     ---------------------------------------------------------- -->

                <div class="editor-header">

                    <div class="editor-header-left">

                        <span class="editor-dot red"></span>
                        <span class="editor-dot yellow"></span>
                        <span class="editor-dot green"></span>

                        <span class="editor-tab">

                            <i class="fa-brands fa-js"></i>

                            {{ nombreArchivo }}

                        </span>

                    </div>


                    <div class="editor-header-right">

                        <span>
                            JavaScript
                        </span>

                    </div>

                </div>


                <!-- ----------------------------------------------------------
                     MONACO
                     ---------------------------------------------------------- -->

                <div class="monaco-wrapper">

                    <ngx-monaco-editor [(ngModel)]="codigo" [options]="editorOptions">
                    </ngx-monaco-editor>

                </div>


                <!-- ----------------------------------------------------------
                     FOOTER EDITOR
                     ---------------------------------------------------------- -->

                <div class="editor-footer">

                    <div>

                        <i class="fa-solid fa-circle-info"></i>

                        Los cambios realizados en el editor se guardarán
                        al presionar <strong>Guardar archivo</strong>.

                    </div>

                </div>

            </div>

        </ng-container>

    </div>


    <!-- ======================================================================
         ACCIONES
         ====================================================================== -->

    <div class="config-file-actions">

        <div class="config-action-info">

            <i class="fa-solid fa-shield-halved"></i>

            <span>
                Asegúrate de validar la configuración antes de utilizarla.
            </span>

        </div>


        <div class="config-action-buttons">

            <!-- PROBAR CONEXIÓN -->

            <button *ngIf="estadoServicioExterno" type="button" class="btn-test-connection" (click)="pruebaConexion()">

                <i class="fa-solid fa-plug"></i>

                <span>
                    Probar conexión
                </span>

            </button>


            <!-- GUARDAR -->

            <button type="button" class="btn-save-file" (click)="subirDocumentos()">

                <i class="fa-solid" [ngClass]="archivo
                        ? 'fa-floppy-disk'
                        : 'fa-cloud-arrow-up'">
                </i>

                <span>
                    {{ archivo ? 'Guardar archivo' : 'Subir archivo' }}
                </span>

            </button>

        </div>

    </div>

</div>



<!-- ==========================================================================
     MODAL RESULTADO CONEXIÓN
     ========================================================================== -->

<ng-template #modalResultadoConexion let-modal>

    <div class="connection-modal">


        <!-- ==================================================================
             HEADER
             ================================================================== -->

        <div class="connection-modal-header">

            <div class="connection-modal-title">

                <div class="connection-title-icon">
                    <i class="fa-solid fa-plug"></i>
                </div>


                <div>

                    <span>
                        CONEXIÓN
                    </span>

                    <h5>
                        Test de conexión
                    </h5>

                </div>

            </div>


            <!-- X PERSONALIZADA -->

            <button type="button" class="modal-close-button" aria-label="Cerrar" (click)="modal.dismiss()">

                <i class="fa-solid fa-xmark"></i>

            </button>

        </div>


        <!-- ==================================================================
             BODY
             ================================================================== -->

        <div class="connection-modal-body">


            <!-- ESTADO -->

            <div class="connection-result">

                <div class="connection-success-icon">

                    <i class="fa-solid fa-check"></i>

                </div>


                <div class="connection-result-content">

                    <span class="connection-status-label">
                        CONEXIÓN ESTABLECIDA
                    </span>

                    <h4>
                        Conectado correctamente
                    </h4>

                    <p>
                        El servicio respondió correctamente a la prueba
                        de conexión.
                    </p>

                </div>

            </div>


            <!-- ==================================================================
                 INFORMACIÓN
                 ================================================================== -->

            <div class="connection-info">


                <!-- SERVIDOR -->

                <div class="connection-info-row">

                    <div class="connection-info-icon">
                        <i class="fa-solid fa-server"></i>
                    </div>


                    <div class="connection-info-content">

                        <span>
                            Servidor
                        </span>

                        <strong>
                            {{ baseUrl }}
                        </strong>

                    </div>

                </div>


                <!-- TIEMPO -->

                <div class="connection-info-row">

                    <div class="connection-info-icon time">
                        <i class="fa-regular fa-clock"></i>
                    </div>


                    <div class="connection-info-content">

                        <span>
                            Tiempo de respuesta
                        </span>

                        <strong>
                            {{ tiempoConexion }} ms
                        </strong>

                    </div>

                </div>

            </div>


            <!-- ==================================================================
                 DETALLES
                 ================================================================== -->

            <div class="connection-details" *ngIf="mostrarDetalle">

                <div class="connection-details-header">

                    <div>

                        <i class="fa-solid fa-code"></i>

                        Respuesta del servidor

                    </div>

                    <span>
                        JSON
                    </span>

                </div>


                <div class="connection-details-code">

                    <pre>{{ respuestaConexion | json }}</pre>

                </div>

            </div>

        </div>


        <!-- ==================================================================
             FOOTER
             ================================================================== -->

        <div class="connection-modal-footer">


            <button type="button" class="btn-connection-details" (click)="toggleDetalle()">

                <i class="fa-solid fa-code"></i>

                <span>
                    {{ mostrarDetalle ? 'Ocultar detalles' : 'Ver detalles' }}
                </span>

                <i class="fa-solid" [ngClass]="mostrarDetalle
                        ? 'fa-chevron-up'
                        : 'fa-chevron-down'">
                </i>

            </button>


            <button type="button" class="btn-connection-accept" (click)="modal.close()">

                <i class="fa-solid fa-check"></i>

                Aceptar

            </button>

        </div>

    </div>

</ng-template>